import { createSlice } from "@reduxjs/toolkit";
import { STATE_NAMES } from "./StateNames";

export enum CONCEPT_BRIEFINGS_PAGE {
    PER_PAGE = 'perPage',
    SORT_BY = 'sortBy',
}

const ConceptBriefingsPageSlice = createSlice({
    name: STATE_NAMES.CONCEPT_BRIEFINGS_PAGE,
    initialState: {
        [CONCEPT_BRIEFINGS_PAGE.PER_PAGE]: null,
        [CONCEPT_BRIEFINGS_PAGE.SORT_BY]: null,
    },
    reducers: {
        setConceptBriefingsPerPage: (state, action) => {
            state[CONCEPT_BRIEFINGS_PAGE.PER_PAGE] = action.payload;
        },
        setConceptBriefingsSortBy: (state, action) => {
            state[CONCEPT_BRIEFINGS_PAGE.SORT_BY] = action.payload;
        },
    },
    selectors: {
        getConceptBriefingsPerPage: state => state[CONCEPT_BRIEFINGS_PAGE.PER_PAGE],
        getConceptBriefingsSortBy: state => state[CONCEPT_BRIEFINGS_PAGE.SORT_BY],
    }
})

export const {
    setConceptBriefingsPerPage,
    setConceptBriefingsSortBy
} = ConceptBriefingsPageSlice.actions;

export const {
    getConceptBriefingsPerPage,
    getConceptBriefingsSortBy
} = ConceptBriefingsPageSlice.selectors;

export default ConceptBriefingsPageSlice.reducer;
